import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
    {
        path: '/tickets',
        component: () => import('@/layouts/ModuleLayout.vue'),
        meta: {
            moduleKey: 'it_requests',
        },
        children: [
            {
                path: '',
                name: 'tickets-list',
                component: () => import('./views/RequestList.vue'),
            },
            {
                path: 'create',
                name: 'tickets-create',
                component: () => import('./views/RequestCreate.vue'),
            },
            {
                path: 'analytics',
                name: 'tickets-analytics',
                component: () => import('./views/TicketAnalyticsDashboard.vue'),
            },
            {
                path: 'sla-dashboard',
                name: 'tickets-sla-dashboard',
                component: () => import('./views/SlaDashboard.vue'),
            },
            {
                path: 'templates',
                name: 'tickets-templates',
                component: () => import('./views/TemplateList.vue'),
            },
            {
                path: 'templates/new',
                name: 'tickets-template-new',
                component: () => import('./views/TemplateForm.vue'),
            },
            {
                path: 'templates/:id',
                name: 'tickets-template-detail',
                component: () => import('./views/TemplateForm.vue'),
                props: true,
            },
            {
                path: 'canned-responses',
                name: 'tickets-canned-responses',
                component: () => import('./views/CannedResponseList.vue'),
            },
            {
                path: 'sla-policies',
                name: 'tickets-sla-policies',
                component: () => import('./views/SlaPolicyList.vue'),
            },
            {
                path: 'settings',
                name: 'tickets-settings',
                component: () => import('./views/TicketSettings.vue'),
            },
            {
                path: 'categories',
                name: 'tickets-categories',
                component: () => import('./views/CategoryManager.vue'),
            },
            {
                path: 'releases',
                name: 'tickets-releases',
                component: () => import('./views/ReleaseManager.vue'),
            },
            {
                path: 'msp-delegation',
                name: 'tickets-msp-delegation',
                component: () => import('./views/MspDelegation.vue'),
            },
            {
                // Must be last — :id is a catch-all param
                path: ':id',
                name: 'tickets-detail',
                component: () => import('./views/RequestDetail.vue'),
                props: true,
            },
        ],
    },
]

export default routes

/**
 * Public routes — registered at top level in router/index.ts.
 * These pages run outside the auth guard and DefaultLayout.
 */
export const publicRoutes: RouteRecordRaw[] = [
    {
        path: '/forms/:token',
        name: 'public-form',
        component: () => import('./views/PublicFormView.vue'),
        props: true,
        meta: {
            title: 'Information Request',
            requiresAuth: false,
        },
    },
]
